/* eslint-disable no-useless-escape */
// regex for form validation
export const regex = { // eslint-disable-line import/prefer-default-export
  /**
   * @type {regexp} dateOfBirth Date of Birth format XX / XX / XXXX
   */
  dateOfBirth: /(0[1-9]|1[012])\s?[\/.]\s?(0[1-9]|[12][0-9]|3[01])\s?[\/.]\s?(19|20)\d\d/,

  /**
   * @type {regexp} email A valid email address
   */
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

  /**
   * @type {regexp} phone Phone number in the format (XXX) XXX-XXXX
   */
  phone: /^\(\d\d\d\)\s\d\d\d-\d\d\d\d/,

  /**
   * @type {regexp} alphanumeric characters only
   */
  alphanumeric: /^[a-zA-Z\d]\w+$/,
};
/* eslint-enable */

export function isPasswordValid(value) {
  let valid = true;
  if (value.length < 8) {
    valid = false;
  }
  return valid;
}

// function to check if a phone number is probably valid
export function isPhoneValid(value) {
  let valid = true;
  // unformat phone number to make it easier
  const unformattedPhone = value.replace(/\D/g, "");

  // numbers can't all be the same digit
  if (/^(.)\1*$/.test(unformattedPhone)) {
    valid = false;
  }

  // numbers can't be 1234567890
  // numbers can't be 0123456789
  if (unformattedPhone === '1234567890' || unformattedPhone === '0123456789') {
    valid = false;
  }
  return valid;
}
// function to check if a phone number is probably valid
export function isAreaCodePhoneValid(value) {
  // unformat phone number to make it easier
  const unformattedPhone = value.replace(/\D/g, "");
  // must be 10 digits long
  const phonelength = unformattedPhone.length;
  // console.log("phone number was " + phonelength + " digits long");
  if (phonelength !== 10) {
    // console.log("phone number is not 10 digits long - was " + phonelength);
    return false;
  }
  // numbers can't all be the same digit
  if (/^(.)\1*$/.test(unformattedPhone)) {
    console.log("phone number is all the same digit");
    return false;
  }
  // numbers can't be 1234567890
  // numbers can't be 0123456789
  if (unformattedPhone === '1234567890' || unformattedPhone === '0123456789') {
  //  console.log("phone number is sequential");
    return false;
  }
  // must not start with 1
  if (/^1/.test(unformattedPhone)) {
    // console.log("phone number begins with 1");
    return false;
  }
  // must not start with 0
  if (/^0/.test(unformattedPhone)) {
    // console.log("phone number begins with 0");
    return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/constants/validation.js